    // Sidebar Component
    const Sidebar = ({ isOpen, toggleSidebar, setView }) => {
      const navItems = [
        { name: 'Dashboard', view: 'dashboard', icon: '🏠' },
        { name: 'JobSeekers', view: 'jobseekers', icon: '👥' },
        { name: 'Job Assignments', view: 'jobAssignments', icon: '💼' },
        { name: 'Attendance', view: 'attendance', icon: '💼' },
        { name: 'Jobs', view: 'jobs', icon: '💼' },
        { name: 'Search History', view: 'searchHistory', icon: '🔍' },
      
        { name: 'Certify JobSeekers', view: 'certifyJobSeekers', icon: '✅' },
      ];

      return (
        <div className={`fixed inset-y-0 left-0 w-64 bg-gray-700 text-white transform ${isOpen ? 'translate-x-0' : '-translate-x-full'} md:translate-x-0 transition-transform duration-300 ease-in-out z-50`}>
          <div className="flex items-center justify-between p-4 border-b border-gray-600">
            <h2 className="text-xl font-bold">Admin Dashboard</h2>
            <button className="md:hidden text-white" onClick={toggleSidebar}>✖</button>
          </div>
          <nav className="mt-4">
            {navItems.map(item => (
              <button
                key={item.view}
                className="w-full text-left py-2 px-4 hover:bg-orange-500 transition-colors"
                onClick={() => { setView(item.view); toggleSidebar(); }}
              >
                <span className="mr-2">{item.icon}</span> {item.name}
              </button>
            ))}
          </nav>
        </div>
      );
    };


    export default Sidebar;